import { FormEvent, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import { loginWithEmail } from '../services/authService';

export const LoginPage = () => {
  const navigate = useNavigate();
  const { login } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [rememberMe, setRememberMe] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    setError(null);
    setLoading(true);

    try {
      const response = await loginWithEmail(email.trim(), password, rememberMe);
      
      // Check if login was successful with remember token (skipped OTP)
      if (response.remembered && response.token && response.user) {
        login(response.token, response.user);
        navigate('/dashboard', { replace: true });
      } else {
        // Normal OTP flow
        navigate('/verify-otp', { state: { email, rememberMe } });
      }
    } catch (err) {
      if (err instanceof Error) {
        setError(err.message);
      } else {
        setError('Unable to start login flow.');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <main className="login-content" style={{ alignItems: 'center' }}>
        <div className="login-card">
          <h2>Sign in to continue</h2>
          <p>Enter your credentials to receive a one-time passcode.</p>

          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="email">Email address</label>
              <input
                id="email"
                type="email"
                autoComplete="email"
                placeholder="you@example.com"
                value={email}
                onChange={(event) => setEmail(event.target.value)}
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="password">Password</label>
              <input
                id="password"
                type="password"
                autoComplete="current-password"
                placeholder="••••••••"
                value={password}
                onChange={(event) => setPassword(event.target.value)}
                required
              />
            </div>

            <div className="form-group" style={{ flexDirection: 'row', alignItems: 'center', gap: 10, marginBottom: 24 }}>
              <input
                id="remember_me"
                type="checkbox"
                checked={rememberMe}
                onChange={(event) => setRememberMe(event.target.checked)}
                style={{ 
                  width: 18, 
                  height: 18, 
                  minHeight: 18, 
                  margin: 0, 
                  cursor: 'pointer',
                  accentColor: 'var(--brand-primary)',
                  flexShrink: 0
                }}
              />
              <label htmlFor="remember_me" style={{ margin: 0, cursor: 'pointer', fontWeight: 400, fontSize: '0.9rem', color: 'var(--neutral-700)' }}>
                Keep me logged in for 7 days
              </label>
            </div>

            {error && <div className="error" style={{ marginBottom: 20 }}>{error}</div>}

            <button className="btn" type="submit" disabled={loading} style={{ marginTop: 4 }}>
              {loading ? 'Signing in…' : 'Continue'}
            </button>
          </form>

          <p className="subtle-text" style={{ marginTop: 32, textAlign: 'center', fontSize: '0.875rem', lineHeight: 1.5 }}>
            Need help? <strong style={{ color: 'var(--brand-primary)', fontWeight: 600 }}>connect@hashsoftware.com</strong>
          </p>
        </div>
      </main>
    </div>
  );
};

